import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-addimagesfs',
  templateUrl: './addimagesfs.component.html',
  styleUrls: ['./addimagesfs.component.scss']
})
export class AddimagesfsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
